export type SupportedLanguage = 'en' | 'nl' | 'de' | 'fr' | 'sv' | 'fi';

export enum SupportedLocale {
  English = 'en',
  Dutch = 'nl',
  German = 'de',
  French = 'fr',
  Swedish = 'sv',
  Finnish = 'fi',
}
